import type { Components, Theme } from "@mui/material";

export const MuiInputLabel: Components<Theme>["MuiInputLabel"] = {
	variants: [
		{
			props: { size: "small" },
			style: {
				"&.MuiInputLabel-root": {
					transform: "translate(14px, 11px) scale(1)",
					"&.MuiInputLabel-shrink": {
						transform: "translate(14px, -9px) scale(0.75)",
					},
				},
			},
		},
		{
			props: { size: "medium" },
			style: {
				"&.MuiInputLabel-root": {
					transform: "translate(14px, 17px) scale(1)",
					"&.MuiInputLabel-shrink": {
						transform: "translate(14px, -9px) scale(0.75)",
					},
				},
			},
		},
	],
};
